export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/provider-hotel.502b383a-9c4582.svg";